import { render, staticRenderFns } from "./PaginaStatisticheScritture.vue?vue&type=template&id=7702da7e"
import script from "./PaginaStatisticheScritture.vue?vue&type=script&lang=js"
export * from "./PaginaStatisticheScritture.vue?vue&type=script&lang=js"
import style0 from "./PaginaStatisticheScritture.vue?vue&type=style&index=0&id=7702da7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports